import request from './request';
import qs from 'qs';

// 获取执行计划列表
export function getCallPlans(params) {
  return request({
    url: '/call-plans',
    method: 'get',
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    }
  });
}

// 创建执行计划（使用默认方案）
export function createCallPlan() {
  return request({
    url: '/call-plans',
    method: 'post'
  });
}

// 获取执行计划详情
export function getCallPlanById(id) {
  return request({
    url: `/call-plans/${id}`,
    method: 'get'
  });
}

// 获取执行计划内容（Agent调用）
export function getCallPlan(id) {
  return request({
    url: `/call-plans/${id}/plan`,
    method: 'get'
  });
}

// 更新计划状态
export function updateCallPlanStatus(id, data) {
  return request({
    url: `/call-plans/${id}/status`,
    method: 'put',
    data
  });
}

// 取消计划
export function cancelCallPlan(id) {
  return request({
    url: `/call-plans/${id}/cancel`,
    method: 'put'
  });
}

// 获取计划的执行日志列表
export function getCallPlanLogs(planId) {
  return request({
    url: `/call-plans/${planId}/logs`,
    method: 'get'
  });
}

// 获取执行日志摘要
export function getCallPlanLogSummary(planId) {
  return request({
    url: `/call-plans/${planId}/logs/summary`,
    method: 'get'
  });
}

// 获取执行日志详情
export function getCallPlanLog(planId, logId) {
  return request({
    url: `/call-plans/${planId}/logs/${logId}`,
    method: 'get'
  });
}

// 创建执行日志
export function createCallPlanLog(planId, data) {
  return request({
    url: `/call-plans/${planId}/logs`,
    method: 'post',
    data
  });
}

// 更新执行日志
export function updateCallPlanLog(planId, logId, data) {
  return request({
    url: `/call-plans/${planId}/logs/${logId}`,
    method: 'put',
    data
  });
}

